module.exports = __webpack_public_path__ + "img/undraw_mail.3124215c.svg";